import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';

import quen_somos from "../../assets/images/banner-quem-somos.png";
import { Image } from 'primereact/image';

const QuemSomosPage: React.FC = () => {

    const styleCard: React.CSSProperties = {
        padding: 2, 
        textAlign: 'center',
        width: "100%",
        aspectRatio: "3/3",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: "0.5em"

    }
    const styleTextCard: React.CSSProperties = {
        textAlign: "left"

    }
  return (
    <Container sx={{ minHeight: '100vh', paddingBottom: 5 }}>
        {/* Welcome Section */}
        <Box sx={{ padding: 3, marginBottom: 4, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Bem-vindo à Innova Plano de Saúde
          </Typography>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Já nascemos grande e contamos com a maior cobertura de Rondônia.
          </Typography>
          <Image src={quen_somos}  width='100%'/>
          {/* <Box sx={{ width: '100%', height: 200, backgroundColor: '#c4c4c4', my: 2 }} /> */}
          <Typography variant="body1">
            A Innova Plano de Saúde já nasce como uma das maiores operadoras de saúde da região,
            oferecendo a mais ampla cobertura em todo o estado de Rondônia. Temos parcerias
            estratégicas com as maiores redes hospitalares, com clínicas e profissionais de
            excelência. Estamos prontos para atender você e sua família com o que há de melhor em
            saúde e bem-estar.
          </Typography>
        </Box>

        {/* Differentials Section */}
        <Box sx={{ padding: 3, marginBottom: 4 }}>
          <Typography variant="h5" gutterBottom>
            Nossos Diferenciais
          </Typography>
          <Typography variant="body1" paragraph>
            Nossa operadora se destaca por oferecer serviços essenciais e especializados, como
            atendimento pediátrico emergencial, UTI neonatal e um dos mais completos programas de
            tratamento oncológico. Nossos planos foram pensados para garantir acesso a tratamentos
            de ponta e a um cuidado humanizado, desde os primeiros dias de vida até as fases mais
            complexas.
          </Typography>
          <Typography variant="body1">
            Ao escolher a Innova, você tem a segurança de contar com um plano que busca a qualidade
            do atendimento individual. A Innova garante que todos os nossos beneficiários tenham
            acesso a um serviço de saúde eficiente, acessível e feito sob medida para as suas
            necessidades.
          </Typography>
        </Box>

        {/* Mission, Vision, and Values */}
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{...styleCard, backgroundColor: "#0786d0"}}>
              <Typography variant="h6" gutterBottom color='#f3f3f3'>
                Missão
              </Typography>
              <Typography style={styleTextCard} variant="body2" color='#f3f3f3'>
                Oferecer soluções de saúde completas e inovadoras, proporcionando aos nossos
                beneficiários atendimento de alta qualidade, com foco na prevenção, no cuidado
                especializado e na humanização em cada etapa do processo.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{...styleCard, backgroundColor: "#61b4c0"}}>
              <Typography variant="h6" gutterBottom>
                Visão
              </Typography>
              <Typography style={styleTextCard} variant="body2">
                Ser referência no setor de planos de saúde em Rondônia, oferecendo a maior cobertura
                do estado e sendo reconhecida pela inovação, pela excelência no atendimento e pelo
                compromisso com a saúde e o bem-estar das pessoas.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box sx={{...styleCard, backgroundColor: "#004387"}}>
              <Typography variant="h6" color='#f3f3f3' gutterBottom>
                Valores
              </Typography>
              <Typography style={styleTextCard} color='#f3f3f3' variant="body2">
                Promover o cuidado humanizado, onde cada pessoa é tratada com respeito e empatia.
                Inovar constantemente, garantindo o melhor em saúde. 
              </Typography>
              <Typography style={styleTextCard} color='#f3f3f3' variant="body2">
                Valorizar a confiança e
                transparência em todos os relacionamentos. Oferecer excelência em atendimento, com
                foco na melhoria contínua e satisfação do cliente. Comprometer-se com a
                acessibilidade, tornando a saúde de qualidade disponível para todos.
              </Typography>
            </Box>
          </Grid>
        </Grid>
    </Container>
  );
};

export default QuemSomosPage;
